'use client';

import { ClipboardCheck } from 'lucide-react';
import { SynthesisCard } from './synthesis-card';
import { useObeyaProjectData } from './use-obeya-project-data';

export function ObeyaQualityCard() {
  const { projectId } = useObeyaProjectData();
  return (
    <SynthesisCard
      title="Data Quality"
      strategy="project_data_quality"
      pinStrategyName="data_quality"
      entitySid={projectId}
      entityParam="project_id"
      emptyLabel="Select a project"
      Icon={ClipboardCheck}
      iconColor="text-green-400"
    />
  );
}
